/* noted. — Skipstone club config. THE ONE PLACE THESE NUMBERS LIVE.

   Config, not code. Change them here and nothing else needs touching. */

/* ---------------------------------------------------------------
   1. TIER MINIMUMS

   Keyed by the bundle's ProductVariant id, which appears in the subscription
   row class and on .bundle-container as pv_<id>.

   SPEND IS THE ONLY MINIMUM. Confirmed by Justin 2026-08-21, from Patricia.
   `bottles: 0` is how that is expressed: the guard still checks the count, it
   simply can never fail. The field is left in place because the rule may come
   back, and a zero is a one-character change.
--------------------------------------------------------------- */
window.SKIPSTONE_TIERS = {
  "54150225953132": { name: "Cave Collector", bottles: 0, spend: 550 },
  "54150226248044": { name: "Wine Vault",     bottles: 0, spend: 1500 },
  "54150226444652": { name: "Cellar Master",  bottles: 0, spend: 3000 }
};

/* ---------------------------------------------------------------
   2. MEMBER PRICING — DISPLAY ONLY. READ THIS BEFORE CHANGING A NUMBER.

   THIS TABLE DOES NOT CHARGE ANYONE. It renders the struck retail price and
   the member price on the allocation rows. The money a member is actually
   billed comes from Awtomic: Tools > Memberships > [tier] > Benefits >
   Product discounts, which drives the Shopify automatic discount
   "Memberships Discount Checkout".

   AWTOMIC SELECTS BY PRODUCT VARIANT, NOT BY PRODUCT. Only the 750ml variant
   of each wine is in either block. That is why no large format carries a
   discount, and why adding a wine here without adding its 750ml variant there
   puts a price on screen that nobody is charged.

   IF THIS TABLE AND AWTOMIC DISAGREE, THE TOTALS DO NOT ADD UP ON SCREEN.
   That is not cosmetic, it is the subtotal bug reported 2026-08-21.

   So every row here must match its Awtomic block exactly, on all three tiers:
     $25 off  ->  the 25 block        $10 off  ->  the 10 block
     absent   ->  in neither block

   MATCH ON THE FULL TITLE INCLUDING THE SIZE. A bare "2024 Oliver's Blend"
   also catches the 1.5L. Same trap on "2023 Faultline", which has a 1.5L.

   A WINE ABSENT FROM THIS TABLE RENDERS AT RETAIL WITH NO STRIKE. That is how
   "no preferred pricing" is expressed, and it is the safe failure for a wine
   nobody remembered: it under-promises rather than over-promises.

   SOURCE: Patricia via Justin, 2026-08-21. Verified against the live Awtomic
   Cave Collector benefits config, 2026-08-24, variant by variant.
     2024 Oliver's Blend 750ml            250 -> 225   ($25)
     2023 Oliver's Blend Cab Sauv 750ml   225 -> 200   ($25)
     2023 Faultline Vineyard 750ml        225 -> 200   ($25)
     2024 Malbec 750ml                    150 -> 140   ($10)
     2023 Malbec 750ml                    150 -> 140   ($10)
     2023 Ripple Effect Cab Sauv 750ml    175 -> 165   ($10)
     2024 Preface 750ml                    85 ->  75   ($10)

   IN AWTOMIC BUT NOT IN THIS RELEASE'S BOX, so not listed here:
     2024 Faultline 750ml, 2024 Sofia's Vineyard 750ml,
     2024 Luka's Blend 750ml ($25); 2024 Ripple Effect 750ml,
     2024 Viognier 750ml, 9th ed. Rose de Constance 750ml ($10).
     ADD THEM HERE THE RELEASE THEY APPEAR IN A BOX.

   DELIBERATELY ABSENT, no preferred pricing, confirmed by Justin:
     2024 Oliver's Blend 1.5L      $500
     2023 Preface 750ml            $85 flat
     2022 Preface Proprietary Red  $85 flat
     2022 Ripple Effect            $175 flat
     2007 Rose de Constance        $200 flat
     every large format of every wine

   UPDATE THIS EVERY RELEASE, IN LOCKSTEP WITH AWTOMIC.
--------------------------------------------------------------- */
window.SKIPSTONE_PRICES = [
  { match: "2024 Oliver's Blend - 750ml",                    retail: 250, member: 225 },
  { match: "2023 Oliver's Blend Cabernet Sauvignon - 750ml", retail: 225, member: 200 },
  { match: "2023 Faultline Vineyard - 750ml",                retail: 225, member: 200 },
  { match: "2024 Malbec - 750ml",                            retail: 150, member: 140 },
  { match: "2023 Malbec - 750ml",                            retail: 150, member: 140 },
  { match: "2023 Ripple Effect Cabernet Sauvignon - 750ml",  retail: 175, member: 165 },
  { match: "2024 Preface - 750ml",                           retail: 85,  member: 75 }
];

/* ---------------------------------------------------------------
   3. FOOTER RECONCILIATION — OFF. READ assets/skipstone-footer-reconcile.js
   BEFORE SETTING THIS TO true.

   false: the allocation footer stays Awtomic's. Where their stamped discount
   lags the corrected benefits config, the Total reads HIGH against the sum of
   the lines. The member is shown more than they are charged. Safe direction.

   true: the discount row and the Total are recomputed from the lines on
   screen. The page reconciles exactly. If Awtomic bills from the stale stamp
   rather than the live config, the member is shown LESS than they are charged.
   Unsafe direction.

   Arm this only once the stamp has been shown to be inert display state.
--------------------------------------------------------------- */
window.SKIPSTONE_RECONCILE_FOOTER = false;

/* ---------------------------------------------------------------
   4. BUNDLE ORDER

   FIRST leads, LAST trails, everything else keeps Awtomic's own order in the
   middle. Matched case-insensitively on the line's product name.
--------------------------------------------------------------- */
window.SKIPSTONE_BUNDLE_ORDER = {
  first: ["oliver's blend", "malbec"],
  last:  ["olive oil"]
};
